
/**
 * @nullable
 */
export type TweetCreateRequestTweetType = typeof TweetCreateRequestTweetType[keyof typeof TweetCreateRequestTweetType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetCreateRequestTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
